import { useEffect, useState } from "react";
import WalletBeneficiariesModal from "../BeneficiariesModal/WalletBeneficiariesModal";
import {
  areFieldsSet,
  beneficiarySelection,
  chooseBeneficiary,
  fetchBanks,
  fetchBeneficiaries,
  verifyWalletNumber,
} from "./WalletTransfterUtils";

export const isCommissionWallet = (productId) =>
  productId.toString() === process.env.REACT_APP_COMMISSION_WALLET_PRODUCT_ID;
function InitiateTransfer({
  handleInitiateTransfer,
  handleChangeTransferDetails,
  user,
  transferDetails,
  receiverName,
  setReceiverName,
  handleSaveBeneficiary,
  showAlert,
  setShowAlert,
}) {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const senderAccount = user.wallets[0].account_no;
  const [showModal, setShowModal] = useState(false);
  const [banks, setBanks] = useState([]);
  const [beneficiarySelected, setBeneficiarySelected] = useState(false);
  const [isExistingBeneficiary, setIsExistingBeneficiary] = useState(false);
  const bankOptions = banks.map((bank) => ({
    // value: bank.code,
    value: `${bank.code}***${bank.name}`,
    label: bank.name,
    bankName: bank.name,
  }));

  useEffect(() => {
    fetchBanks(setBanks);
    fetchBeneficiaries(senderAccount, setBeneficiaries);
  }, [senderAccount]);

  const handleVerifyWalletNo = () => {
    verifyWalletNumber(
      transferDetails,
      setReceiverName,
      beneficiaries,
      setIsExistingBeneficiary,
      senderAccount,
      setBeneficiaries
    );
  };

  // Integrate fetching beneficiary into the handleChooseBeneficiary function.
  const handleChooseBeneficiary = async () => {
    chooseBeneficiary(
      senderAccount,
      setBeneficiaries,
      setShowModal,
      bankOptions
    );
  };

  const handleBeneficiarySelection = async (beneficiary) => {
    beneficiarySelection(
      beneficiary,
      setReceiverName,
      handleChangeTransferDetails,
      setShowModal,
      setBeneficiarySelected
    );
  };

  const fieldsAreSet = areFieldsSet(transferDetails);

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Initiate Transfer to Another Wallet</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">
            Transfer Money to Another Wallet
          </h3>
          <form onSubmit={handleInitiateTransfer}>
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="senderWalletNumber">
                From Wallet
              </label>
              <select
                className="form-control"
                name="sender_wallet_number"
                id="senderWalletNumber"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Wallet--</option>
                {/* Exclude Savings wallet as it is not a transactable */}
                {user.wallets
                  .filter(
                    (wallet) =>
                      !isCommissionWallet(wallet.product_id) &&
                      wallet.type !== "savings",
                  )
                  .map((wallet) => (
                    <option value={wallet.account_no} key={wallet.id}>
                      {wallet.name} (&#8358;
                      {Number(wallet.balance).toFixed(2).toLocaleString()})
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <label className="form-label" htmlFor="receiverWalletNumber">
                  To Wallet
                </label>
                <button
                  type="button"
                  className="btn btn-link fw-bolder text-decoration-none"
                  onClick={handleChooseBeneficiary}
                >
                  Choose Beneficiary
                </button>
              </div>
              <input
                name="receiver_wallet_number"
                id="receiverWalletNumber"
                type="text"
                className="form-control"
                placeholder="Receiver Wallet Number"
                title="Numbers only"
                maxLength="12"
                required
                onChange={handleChangeTransferDetails}
                value={transferDetails.receiver_wallet_number}
              />
              <div className="mt-2">
                <span
                  className="btn btn-primary-soft"
                  onClick={handleVerifyWalletNo}
                >
                  Validate
                </span>
              </div>
            </div>
            <div className="form-group mb-3">
              <input
                className="form-control"
                type="text"
                value={receiverName}
                // readOnly
                disabled
              />
            </div>

            {showModal && (
              <WalletBeneficiariesModal
                beneficiaries={beneficiaries}
                setBeneficiaries={setBeneficiaries}
                handleBeneficiarySelection={handleBeneficiarySelection}
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                showModal={showModal}
                setShowModal={setShowModal}
              />
            )}

            <div className="form-group mb-5">
              <label className="form-label" htmlFor="transferAmount">
                Amount &#8358;
              </label>

              <input
                name="transfer_amount"
                id="transferAmount"
                type="number"
                className="form-control"
                placeholder=""
                title="Positive numbers only"
                maxLength="10"
                required
                onChange={handleChangeTransferDetails}
                step="0.01" // Accommodate for decimal values
                onWheel={(e) => e.target.blur()} //Disable scrolling
              />
            </div>
            <div className="form-group mb-5">
              <label className="form-label" htmlFor="narration">
                Narration (Optional)
              </label>

              <input
                name="narration"
                id="narration"
                type="text"
                className="form-control"
                placeholder=""
                maxLength="30"
                onChange={handleChangeTransferDetails}
              />
            </div>
            <div className="form-check mb-5">
              {!isExistingBeneficiary && !beneficiarySelected && (
                <>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="saveBeneficiaryCheckbox"
                    aria-label="Save Beneficiary"
                    aria-checked={false}
                    onChange={() => {
                      handleSaveBeneficiary();
                    }}
                  />
                  <label
                    htmlFor="saveBeneficiaryCheckbox"
                    className="form-check-label"
                  >
                    Save Beneficiary
                  </label>
                </>
              )}
            </div>

            <button
              type="submit"
              className="btn w-100 btn-primary"
              disabled={!fieldsAreSet}
            >
              Proceed
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default InitiateTransfer;
